import React, { ReactElement, Component, Fragment } from "react";

const User: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    return (
        <Fragment>
            {props.children}
        </Fragment>
    )
}

export default User;